module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/ZoomMinus-d7c9d9f314a1b0375faae2ce2698c41f.svg";